import { useMemo } from "react";
import { DEFAULT_SLIDES_PER_VIEW } from "../Carousel";
import { useBreakpoints } from "../../../../hooks/useBreakpoint";

const parseToArray = (el: number[] | number, length: number) =>
    Array.isArray(el) ? el : (Array.from({ length }).fill(el) as number[]);

export const useSlidesPerView = (unparsedSlidesPerView: number[] | number) => {
    const { base, md, lg, xl } = useBreakpoints(["base", "md", "lg", "xl"]);

    const parsedSlidesPerViewValue = parseToArray(
        unparsedSlidesPerView,
        (unparsedSlidesPerView as number[])?.length || 3
    );

    const slidesPerView = useMemo(() => {
        if (xl) {
            return (
                parsedSlidesPerViewValue[3] ??
                parsedSlidesPerViewValue[2] ??
                parsedSlidesPerViewValue[0]
            );
        }
        if (lg) {
            return parsedSlidesPerViewValue[2] ?? parsedSlidesPerViewValue[0];
        }
        if (md) {
            return parsedSlidesPerViewValue[1] ?? parsedSlidesPerViewValue[0];
        }
        if (base) {
            return parsedSlidesPerViewValue[0];
        }
        return DEFAULT_SLIDES_PER_VIEW;
    }, [base, md, lg, xl, parsedSlidesPerViewValue]);

    return { slidesPerView };
};
